<div *ngFor="let elemento of elementos; let i = index" class="collapse" [attr.indice]="i"
    [ngClass]="{'collapse-on': (elemento.opened) ||(itemInicialActivo>=0 && i == itemInicialActivo)}"
    [attr.data-group]="'faq'">
    <ng-container *ngIf="elemento.linkHref && elemento.linkHref != ''; else template">
        <div class="collapse-root">
            <neo-contenido-titulo></neo-contenido-titulo>
            <button type="button" (click)="collapseToggle(elemento, undefined, i)">
                <i class="icon-opened"
                    [ngClass]="(elemento?.iconOpened && elemento.iconOpened != '') ? elemento.iconOpened : 'icon-24 icon-ibm-subtract'"></i>
                <i class="icon-closed"
                    [ngClass]="(elemento?.iconClosed && elemento.iconClosed != '') ? elemento.iconClosed : 'icon-24 icon-ibm-add'"></i>
            </button>
        </div>
    </ng-container>
    <ng-template #template>
        <button class="collapse-root" type="button" (click)="collapseToggle($event, elemento, i)">
            <span>
                <neo-contenido-titulo [titleTag]="elemento.titleTag" [titleText]="elemento.tituloTexto">
                </neo-contenido-titulo>
            </span>
            <i class=" icon-opened"
                [ngClass]="(elemento?.iconOpened && elemento.iconOpened != '') ? elemento.iconOpened : 'icon-24 icon-ibm-subtract'">
            </i>
            <i class="icon-closed"
                [ngClass]="(elemento?.iconClosed && elemento.iconClosed != '') ? elemento.iconClosed : 'icon-24 icon-ibm-add'"></i>
        </button>
    </ng-template>
    <div class="collapse-cont">
        <neo-span-inner-html [contenido]="elemento.contenido"></neo-span-inner-html>
    </div>
</div>